import './button.scss';

type buttonType = {
  children: string | JSX.Element;
  variant?: 'primary' | 'secondary' | 'teriary';
  icon?: JSX.Element;
  className?: string;
  isIcon?: 'left' | 'right' | '';
  style?: object;
  onClick?: Function;
};

const Button = ({
  children,
  variant = 'primary',
  className = '',
  isIcon = '',
  icon,
  style = {},
  onClick,
}: buttonType) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      style={style}
      className={`main-btn ${className} ${isIcon} ${variant}`}
    >
      {icon}
      {children}
    </button>
  );
};

export default Button;
